import { Zoom, makeStyles, useScrollTrigger } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: 100,
    [theme.breakpoints.down("sm")]: {
      bottom: 77
    },
    [theme.breakpoints.down("xs")]: {
      bottom: 97
    }
  },
  customBottomNavigation: {
    alignItems: "center",
    height: 69
  }
}));

export const ScrollTopButton = (props: { children: JSX.Element }) => {
  const { children } = props;
  const classes = useStyles();
  const trigger = useScrollTrigger({
    target: window ? window : undefined,
    disableHysteresis: true,
    threshold: 100
  });

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.root}>
        {children}
      </div>
    </Zoom>
  );
};
